export default __webpack_public_path__ + "static/14-45841dc8183bea538d61513fb8490373.png";